export function SettingsPanel({ id, title, children }: { id?: string; title?: string; children: React.ReactNode }) {
  return (
    <section id={id} className="grid min-w-0 gap-3 rounded-xl border bg-card p-5 text-card-foreground">
      {title && <h2 className="font-semibold">{title}</h2>}
      {children}
    </section>
  );
}
